// Plugin to fix Pinia payload hydration issues
export default defineNuxtPlugin({
  name: 'pinia-payload-fix',
  setup(nuxtApp) {
    // Disable problematic payload reducers that cause hydration mismatches
    if (process.client) {
      // Override the skipHydrate payload reducer to prevent hydration issues
      nuxtApp.hook('app:created', () => {
        console.log('[pinia-payload-fix] Disabling problematic payload reducers')
        
        // Clear any existing skipHydrate reducers
        if (nuxtApp.payload && nuxtApp.payload.data) {
          delete nuxtApp.payload.data.skipHydrate
        }
      })
    }
  }
})
